import React from "react";
import Categories from "../Component/Categories";
import Section from "../Component/Section";
import WhenYouNeedHelp from "../Component/WhenYouNeedHelp";

const HomePage = () => {
  return (
    <>
      <Section />

      <Categories />
      <WhenYouNeedHelp />
    </>
  );
};

export default HomePage;
